import React from 'react';
import { APITypes } from '../../../../../primary-record-types';
import getName from '../../../../../utils/getName';
import * as Card from '../../../../v2BaseComponents/Card';
import { getIntl } from '../../../../../utils/intl';
import urls from '../../../../../utils/urls';
import { getPermissionsDescription } from '../../../../../utils/evaluatePermissions';
import Stack from '../../../../v2BaseComponents/Stack';
import { LoadableAvatar } from '../../../../v2BaseComponents/Avatar';

const intl = getIntl('CollaboratorCard', {
    profileAccess: 'Profile Access',
    view: 'View',
    edit: 'Edit',
    none: 'None',
    permissions: 'Permissions: {permissions}',
});

export type CollaboratorCardOwnProps = {
    medicalProfileId: string;
    collaborator: APITypes.medicalProfileService.MedicalProfileUserCollaborator;
    onSelect: (collaboratorId: string) => void;
    isDisabled?: boolean;
};

export type CollaboratorCardProps = CollaboratorCardOwnProps;

const CollaboratorCard: React.FC<CollaboratorCardProps> = (props) => {
    const getDetails = (): string => {
        if (!props.collaborator.appPermissions) return '';

        return intl('permissions', { permissions: getPermissionsDescription(props.collaborator.appPermissions) });
    };

    return (
        <Card.Card
            onPress={() => props.onSelect(props.collaborator.medicalProfileCollaboratorId)}
            isDisabled={props.isDisabled}
        >
            <Card.CardLeftContent
                leftContent={
                    <Stack vertical justify="center">
                        <LoadableAvatar
                            avatarUrl={urls.api.collaborators.collaboratorAvatar(
                                props.medicalProfileId,
                                props.collaborator.medicalProfileCollaboratorId,
                            )}
                            firstName={props.collaborator.user.firstName}
                            lastName={props.collaborator.user.lastName}
                            size="sm"
                        />
                    </Stack>
                }
            >
                <Card.CardContent>
                    <Card.CardHeader>{getName(props.collaborator.user)}</Card.CardHeader>
                    <Card.CardBody2>{getDetails()}</Card.CardBody2>
                </Card.CardContent>
            </Card.CardLeftContent>
        </Card.Card>
    );
};

export default React.memo(CollaboratorCard);
